import ChallengeInfoElem from './ChallengeInfoElem';

export default ChallengeInfoElem;
